"use client";

import { c as _c } from "react/compiler-runtime";
import FileIcon from "~/components/icons/file-icon-eon";
import InterviewIcon from "~/components/icons/interview-icon-eon";
import PcMacIcon from "~/components/icons/pc-mac-icon-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
import SectionIntro from "./application-process-intro-eon";
import ApplicationProcessSlider, { type Step } from "./application-process-slider-eon";
export default function ApplicationProcess(_props) {
  const $ = _c(19);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PcMacIcon className="size-16" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.jobad_process_step01_text || $[2] !== t.jobad_process_step01_title) {
    t1 = {
      id: 1,
      title: t.jobad_process_step01_title,
      text: t.jobad_process_step01_text,
      iconHighlight: t0
    };
    $[1] = t.jobad_process_step01_text;
    $[2] = t.jobad_process_step01_title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <InterviewIcon className="size-16" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t.jobad_process_step02_text || $[6] !== t.jobad_process_step02_title) {
    t3 = {
      id: 2,
      title: t.jobad_process_step02_title,
      text: t.jobad_process_step02_text,
      iconHighlight: t2
    };
    $[5] = t.jobad_process_step02_text;
    $[6] = t.jobad_process_step02_title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FileIcon className="size-16" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t.jobad_process_step03_text || $[10] !== t.jobad_process_step03_title) {
    t5 = {
      id: 3,
      title: t.jobad_process_step03_title,
      text: t.jobad_process_step03_text,
      iconHighlight: t4
    };
    $[9] = t.jobad_process_step03_text;
    $[10] = t.jobad_process_step03_title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
    t6 = [t1, t3, t5];
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const steps = t6;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SectionIntro />;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== steps) {
    t8 = <section className="outer-container py-container" id="applicationProcess"><div className="inner-container">{t7}<ApplicationProcessSlider steps={steps} /></div></section>;
    $[17] = steps;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}